import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import type { CreateLabelParams } from './helpers';
import { createCtaLabel } from './helpers';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CTA_CLICKED } = SNOWPLOW_EVENTS;

interface TriggerSellerMessagingConfirmMarkAsContactedButtonClickedEventParams {
	buttonLabel: string;
	response: CreateLabelParams;
	success: boolean;
	url: string;
}

export const triggerSellerMessagingConfirmMarkAsContactedButtonClickedEvent = ({
	buttonLabel,
	response: { failedToUpdateEnquiries, updatedEnquiryIds },
	success,
	url,
}: TriggerSellerMessagingConfirmMarkAsContactedButtonClickedEventParams): void => {
	const label = createCtaLabel({ failedToUpdateEnquiries, updatedEnquiryIds });
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		customData: { button_label: buttonLabel, label, success, url },
		name: 'dlr_seller_messaging_confirm_mark_as_contacted_button_clicked',
		schemaName: CTA_CLICKED.SCHEMA,
		version: CTA_CLICKED.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
